// extracted by mini-css-extract-plugin
export var integrationButton = "_a7-0";